module.exports = __webpack_public_path__ + "static/SoundMate-9c7d69147b85eaef66902710c4f65afa.jpg";